export default __webpack_public_path__ + "static/media/Hair_3_M_C4.013c4719.svg";